var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mediaClasses},[_c('div',{class:_vm.asideClasses},[_vm._t("aside",function(){return [_c('CImg',_vm._b({},'CImg',_vm.computedAsideImageProps,false))]})],2),_c('div',{class:_vm.mediaBodyClasses},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }